import { call, put, takeEvery } from 'redux-saga/effects';

import { resolveCrfByPeriod } from 'src/crf';
import {
  receiveAPIResponseHoldingData,
  requestAPIFailedHoldingData,
} from 'src/redux/api/actions';
import { apiCallAsync } from 'src/redux/api/saga';
import { REPORT_LIST_DATA_KEY } from 'src/redux/constants';
import { showNotification } from 'src/utils';
import { GET_PUBLICATION_LIST_REQUEST } from './actions';
import { GetPublicationListRequestAction } from './types';

export function* PublicationStatusApiCallSaga(
  action: GetPublicationListRequestAction,
) {
  try {
    const { period } = action.payload;
    const base = resolveCrfByPeriod(period).listUrl();
    const url = period
      ? `${base}?period=${encodeURIComponent(String(period))}`
      : base;

    const response = yield call(apiCallAsync, url);

    if (response.status >= 200 && response.status < 300) {
      yield put(
        receiveAPIResponseHoldingData(response.data, REPORT_LIST_DATA_KEY),
      );
    } else {
      throw new Error('Publication Status API call has failed');
    }
  } catch (e) {
    yield put(
      requestAPIFailedHoldingData(REPORT_LIST_DATA_KEY, {
        message: e.message,
        data: e.response ? e.response.data : null,
      }),
    );
    showNotification(e.message || 'Error', 'error');
    console.error(e);
  }
}

export default function* getPublicationStatusSaga() {
  yield takeEvery(GET_PUBLICATION_LIST_REQUEST, PublicationStatusApiCallSaga);
}
